export const PERMISSION_NAMES = {
  CAN_SEE_JUVENILE_REPORT: 'Can see juvenile report',
  DNA_SAMPLES: 'DNA Samples',
  EMPLOYEES: 'Employees',
  MERGE_PEOPLE: 'Merge People',
  ZONES: 'Zones',
  PROPERTY: 'Property',
  ALERTS: 'Alerts',
  PEOPLE: 'People',
  ADDRESSES: 'Addresses',
  PLACES: 'Places',
  VEHICLES: 'Vehicles',
};
